<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Date of Birth Page" aria-live="polite" role="contentinfo"></span>
    <v-card>
      <v-card-text class="centerContainer">
        <div :class="isRTLLanguage ? 'rtl' : 'normal'">
          <p><span><strong> {{ siteText.ui.serviceSelectedService }} </strong></span>{{ selectedService1.Name  }}
             <span v-if="displaySelectedService2">, &nbsp; {{ selectedService2.Name }} </span>
          </p>
          <p> {{ selectedService1.AdditionalInfoText }} 
            <a
              target="_blank"
              :href='selectedService1.Url'
            >{{ selectedService1.UrlText }}</a>
          </p>
        </div>
        <div v-if="displaySelectedService2">
          <!-- <p><span><strong> {{ siteText.ui.serviceSelectedService2 }} </strong></span>{{ selectedService2.Name  }}</p> -->
          <p> {{ selectedService2.AdditionalInfoText  }} 
            <a
              target="_blank"
              :href='selectedService2.Url'
            >{{ selectedService2.UrlText }}</a>
          </p>
        </div>
        <!-- TODO: Refactor the following to replace text based on the MinimumAge property of the selected service -->
        <p v-if="displayDOB16YearsOldText" :class="isRTLLanguage ? 'rtl' : 'normal'"> {{ siteText.ui.dOB16YearsOldText }} </p>
        <p v-if="displayDOB18YearsOldText" :class="isRTLLanguage ? 'rtl' : 'normal'"> {{ siteText.ui.dOB18YearsOldText }} </p>
        <p :class="isRTLLanguage ? 'rtl' : 'normal'"><strong> {{ siteText.ui.dOBDateOfBirthLabel }} </strong></p>
        <!-- <v-select :label="siteText.ui.dOBDateOfBirthMonth" :class="{'v-text-field--reverse': isRTLLanguage }"
                       :items="months" item-text="Text" item-value="Code" v-model="month" filled dense
        ></v-select> -->
        <!-- <vc-select class="vc-select bold" :searchable="false" :clearable="false" :options="months" 
                   label="Text" value="Code" v-model="month" >
        </vc-select> -->
        <opus-select-only-drop-down
          :items="months"
          select-name="monthSelect"
          item-label="Text"
          item-id="Code"
          :place-holder="siteText.ui.dOBDateOfBirthMonth"
          aria-label="Select a month"
          v-model="month"
        >
        </opus-select-only-drop-down>
        <p>&nbsp;</p>
        <!-- <v-select :label="siteText.ui.dOBDateOfBirthDay" :class="{'v-text-field--reverse': isRTLLanguage }"
                       :items="days" item-text="Text" item-value="Code" v-model="day" filled dense
        ></v-select> -->
        <!-- <vc-select class="vc-select bold" :searchable="false" :clearable="false" :options="days" 
                   label="Text" value="Code" v-model="day" >
        </vc-select> -->
        <opus-select-only-drop-down
          :items="days"
          select-name="daySelect"
          item-label="Text"
          item-id="Code"
          :place-holder="siteText.ui.dOBDateOfBirthDay"
          aria-label="Select a day"
          v-model="day"
        >
        </opus-select-only-drop-down>
        <p>&nbsp;</p>
        <!-- <v-select :label="siteText.ui.dOBDateOfBirthYear" :class="{'v-text-field--reverse': isRTLLanguage }"
                       :items="years" item-text="Text" item-value="Code" v-model="year" filled dense
        ></v-select> -->
        <!-- <vc-select class="vc-select bold" :searchable="false" :clearable="false" :options="years" 
                        label="Text" value="Code" v-model="year" >
        </vc-select> -->
        <opus-select-only-drop-down
          :items="years"
          select-name="yearSelect"
          item-label="Text"
          item-id="Code"
          :place-holder="siteText.ui.dOBDateOfBirthYear"
          aria-label="Select a year"
          v-model="year"
        >
        </opus-select-only-drop-down>
        <p>&nbsp;</p>
        <p v-if="displayDateOfBirth" :class="isRTLLanguage ? 'rtl' : 'normal'"><strong>{{ siteText.ui.dOBDateOfBirthSelected }} {{ month.Text }}/{{ day.Text }}/{{ year.Text }} </strong></p>
        <p class="red--text" v-if="displayInvalidDOBMessage" :class="isRTLLanguage ? 'rtl' : 'normal'"><strong>{{ siteText.errors.error }}</strong> {{ siteText.errors.invalidDOBMessage }} </p>
      </v-card-text>
    </v-card>
    <p></p>
    <div class="text-left pt-md-4">
      <!-- Desktop Layout -->
      <v-layout row wrap class="hidden-sm-and-down">
      <v-flex md3>
      <v-btn
        class="ma-2 dmv-btn"
        height="45px"
        width="260px"
        @click="back()"
        ><v-icon>mdi-arrow-left</v-icon>
        {{ siteText.ui.dOBBack }}
      </v-btn>
      </v-flex>
      <v-flex md3>
      <v-btn
        class="ma-2 dmv-btn"
        height="45px"
        width="260px"
        :disabled="disableSubmit"
        :aria-disabled="disableSubmit"
        @click="dOBSubmit()"
      >
        {{ siteText.ui.dOBSubmit }}
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      </v-flex>
      </v-layout>
      <!-- Mobile Layout -->
      <v-layout row wrap class="hidden-md-and-up">
        <v-flex xs12>
          <v-btn
          class="ma-2 dmv-btn"
          height="45px"
          width="260px"
          :disabled="disableSubmit"
          :aria-disabled="disableSubmit"
          @click="dOBSubmit()"
        >
          {{ siteText.ui.dOBSubmit }}
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
        </v-flex>
        <v-flex xs12>
        <v-btn
          class="ma-2 dmv-btn"
          height="45px"
          width="260px"
          @click="back()"
          ><v-icon>mdi-arrow-left</v-icon>
          {{ siteText.ui.dOBBack }}
        </v-btn>
        </v-flex>
        </v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OpusSelectOnlyDropDown from "@/components/OpusSelectOnlyDropDown.vue";

export default {
  name: 'DateOfBirthPage',
  data: () => ({
    months: [
     { Code: '01', Text: '01'},
     { Code: '02', Text: '02'},
     { Code: '03', Text: '03'},
     { Code: '04', Text: '04'},
     { Code: '05', Text: '05'},
     { Code: '06', Text: '06'},
     { Code: '07', Text: '07'},
     { Code: '08', Text: '08'},
     { Code: '09', Text: '09'},
     { Code: '10', Text: '10'},
     { Code: '11', Text: '11'},
     { Code: '12', Text: '12'},
    ],
    month: '',
    days: [
     { Code: '01', Text: '01'},
     { Code: '02', Text: '02'},
     { Code: '03', Text: '03'},
     { Code: '04', Text: '04'},
     { Code: '05', Text: '05'},
     { Code: '06', Text: '06'},
     { Code: '07', Text: '07'},
     { Code: '08', Text: '08'},
     { Code: '09', Text: '09'},
     { Code: '10', Text: '10'},
     { Code: '11', Text: '11'},
     { Code: '12', Text: '12'},
     { Code: '13', Text: '13'},
     { Code: '14', Text: '14'},
     { Code: '15', Text: '15'},
     { Code: '16', Text: '16'},
     { Code: '17', Text: '17'},
     { Code: '18', Text: '18'},
     { Code: '19', Text: '19'},
     { Code: '20', Text: '20'},
     { Code: '21', Text: '21'},
     { Code: '22', Text: '22'},
     { Code: '23', Text: '23'},
     { Code: '24', Text: '24'},
     { Code: '25', Text: '25'},
     { Code: '26', Text: '26'},
     { Code: '27', Text: '27'},
     { Code: '28', Text: '28'},
     { Code: '29', Text: '29'},
     { Code: '30', Text: '30'},
     { Code: '31', Text: '31'},
    ],
    day: '',
    year: '',
    service1DOB16: false,
    service1DOB18: false,
    service2DOB16: false,
    service2DOB18: false,
  }),
  components: {
    OpusSelectOnlyDropDown,
  },
  methods: {
    ...mapActions(['dateOfBirth']),
    nextPage(page) {
      this.$emit('navigateTo', page);
    },
    back() {
      this.$emit('navigateTo', 'SelectServicePage', { 
          pageName:'Select Service for Reservation'
      });
    },
    dOBSubmit() {
      this.dateOfBirth(this.formattedDateOfBirth);
      console.log(this.formattedDateOfBirth);
      this.$emit('navigateTo', 'SelectLocationCountyPage', { 
          pageName:'Select DMV Office Location'
      });
    },
  },
  computed: {
    ...mapGetters(['siteText', 'isRTLLanguage']),
    ...mapGetters('selectedService', [
      'numberOfServices',
      'selectedService1',
      'selectedService2'
    ]),
    displaySelectedService2() {
      if (this.numberOfServices === 2) {
          return true;
      }
      return false;
    },
    //TODO: refactor the following to use selectedService1.MinimumAge and selectedService2.MinimumAge
    displayDOB16YearsOldText() {
      if (this.numberOfServices === 1 && !this.service1DOB18) {
        return true;
      }
      if (this.numberOfServices === 2 && (!this.service1DOB18  && !this.service2DOB18)) {
        return true;
      }
      return false;
    },
    displayDOB18YearsOldText() {
      if (this.numberOfServices === 1 && this.service1DOB18) {
        return true;
      }
      if (this.numberOfServices === 2 && (this.service1DOB18  || this.service2DOB18)) {
        return true;
      }
      return false;
    },
    years() {
      const d = new Date();
      let currentYear = d.getFullYear();
      let currentMonth = d.getMonth();
      // Subtract 15, instead of 16, if birth month is December because 30 days within birth date makes year to be next year
      // Else, subtract 16
      let yearUpper;
      let arraySize;
      if (currentMonth === 11) {
        yearUpper = currentYear - 15 + 1;
        arraySize = 99 - 15 + 1;
        if (this.service1DOB18) {
          yearUpper = currentYear - 17 + 1;
          arraySize = 99 - 17 + 1;
        }
        if (this.numberOfServices === 2 && this.service2DOB18) {
          yearUpper = currentYear - 17 + 1;
          arraySize = 99 - 17 + 1;
        }
      } else {
        yearUpper = currentYear - 16 + 1;
        arraySize = 99 - 16 + 1;
        if (this.service1DOB18) {
          yearUpper = currentYear - 18 + 1;
          arraySize = 99 - 18 + 1;
        }
        if (this.numberOfServices === 2 && this.service2DOB18) {
          yearUpper = currentYear - 18 + 1;
          arraySize = 99 - 18 + 1;
        }
      }
      console.log(currentYear);
      console.log(yearUpper);
      let yearsArray = new Array(arraySize);
      for (let i = currentYear - 99; i < yearUpper; i += 1) {
        yearsArray[i] = { Code: i, Text: i.toString() };
      }
      return yearsArray.reverse();
    },
    displayDateOfBirth() {
      if (this.month.Code !== '' && this.month.Code !== undefined
       && this.day.Code !== '' && this.day.Code !== undefined
       && this.year.Code !== '' && this.year.Code !== undefined) {
        return true;
      }
      return false;
    },
    displayInvalidDOBMessage() {
      if (this.month.Code !== '' && this.day.Code !== '' && this.year.Code !== '') {
        const dToday = new Date();
        const dBirthDay = new Date(this.year.Code, this.month.Code - 1, this.day.Code);
        let age = 16;
        if (this.service1DOB18) {
          age = 18;
        }
        if (this.numberOfServices === 2 && this.service2DOB18) {
          age = 18;
        }
        const dAge = new Date(dToday.getFullYear() - age, dToday.getMonth(), dToday.getDate());
        console.log(dAge.getTime());
        console.log(dBirthDay.getTime());
        console.log(dAge.getMonth() + ' ' + dAge.getDate() + ' ' + dAge.getFullYear());
        console.log(dBirthDay.getMonth() + ' ' + dBirthDay.getDate() + ' ' + dBirthDay.getFullYear());
        // older is smaller, younger is bigger
        // getTime() returns the number of milliseconds since January 1, 1970:
        // as of 11/07/2022 for today it is about 1667846696170 milliseconds
        if (dAge.getTime() + 30 * 24 * 60 * 60 * 1000 < dBirthDay.getTime()) {
          console.log('dAge + 30 days < dBirthDay');
          return true;
        }
      }
      return false;
    },
    disableSubmit() {
      if (this.displayDateOfBirth && !this.displayInvalidDOBMessage) {
        return false;
      }
      return true;
    },
    formattedDateOfBirth() {
      return `${this.month.Text}/${this.day.Text}/${this.year.Text}`;
    }
  },
  mounted() {
    if (this.selectedService1.MinimumAge === 16) {
      this.service1DOB16 = true;
    } else if (this.selectedService1.MinimumAge === 18) {
      this.service1DOB18 = true;
    }
    if (this.selectedService2.MinimumAge === 16) {
      this.service2DOB16 = true;
    } else if (this.selectedService2.MinimumAge === 18) {
      this.service2DOB18 = true;
    }
    console.log(this.service1DOB16);
    console.log(this.service1DOB18);
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
